import { Directive, ViewParent } from 'angular-ts-decorators';

/**
 * Directive that adds password related validation to the field
 *
 * @example
 * <any sw-password-validation></any>
 */
@Directive({
  selector: '[sw-password-validation]',
  require: 'ngModel',
  bindToController: true,
})
export class SwPasswordValidationDirective {
  @ViewParent('?') private ngModel: ng.INgModelController;

  constructor() {
    'ngInject';
  }

  // TODO add unit tests
  $postLink() {
    this.ngModel.$validators.oneUppercaseLetter = (value) => {
      return /[A-Z]/.test(value);
    };

    this.ngModel.$validators.oneLowercaseLetter = (value) => {
      return /[a-z]/.test(value);
    };

    this.ngModel.$validators.oneNumber = (value) => {
      return /[0-9]/.test(value);
    };

    this.ngModel.$validators.oneSpecialCharacter = (value) => {
      return /[!@#\$%\^&\*\(\)\-_\+=\{\}\[\]:;"'<>,\.\?\/\\|`~]/.test(value);
    };

    this.ngModel.$validators.minLength = (value) => {
      return value.length >= 10;
    };
  }
}
